import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const useBackNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, dir } = useLanguage();
  
  // Determine if we should show the back button based on current route
  const shouldShowBackButton = () => {
    const path = location.pathname;
    return path.startsWith('/tours/') || path.startsWith('/exhibit/');
  };
  
  // Get the appropriate back icon based on text direction
  const getBackIcon = () => {
    return dir === 'rtl' ? ChevronRight : ChevronLeft;
  };
  
  // Handle back navigation based on current location and state
  const handleBack = () => {
    const path = location.pathname;
    const state = location.state || {};
    
    // Tour detail page logic
    if (path.startsWith('/tours/')) {
      const fromCMS = state.from === 'cms';
      if (fromCMS) {
        navigate('/cms/tours');
      } else {
        navigate('/tours');
      }
      return;
    }
    
    // Exhibit page logic
    if (path.startsWith('/exhibit/')) {
      // Check if we came from a tour
      if (state.from && typeof state.from === 'string' && state.from.startsWith('tour-')) {
        const tourId = state.from.replace('tour-', '');
        navigate(`/tours/${tourId}`);
        return;
      }
      
      // Check for other referrer types from state
      if (state.from === 'keypad') {
        navigate('/exhibit-access?mode=keypad');
      } else if (state.from === 'qr') {
        navigate('/exhibit-access?mode=qr');
      } else if (state.referrer === 'cms') {
        navigate('/cms/exhibits');
      } else {
        // Default fallback for exhibits
        navigate('/tours');
      }
      return;
    }
  };
  
  // Get back button text
  const getBackText = () => {
    const path = location.pathname;
    const state = location.state || {};
    
    if (path.startsWith('/tours/') && state.from === 'cms') {
      return 'Back to CMS';
    }
    
    return t('back');
  };
  
  return {
    shouldShowBackButton: shouldShowBackButton(),
    handleBack,
    getBackIcon,
    getBackText,
  };
};